import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { Spinner } from '@gouvfr-lasuite/ui-kit';

import ProjectsContainer from '../../containers/ProjectsContainer';
import BoardContainer from '../../containers/BoardContainer';
import BoardActionsContainer from '../../containers/BoardActionsContainer';

import styles from './Static.module.scss';

function Static({ projectId, cardId, board }) {
  const [t] = useTranslation();

  // ─── Vue Kanban ↔ Hiérarchique ───
  // TODO Phase 7 : remplacer par un settings persisté (backend) au lieu d'un state local
  const [viewMode, setViewMode] = useState('kanban'); // 'kanban' | 'hierarchy'
  const handleToggleView = useCallback(() => {
    setViewMode((prev) => (prev === 'kanban' ? 'hierarchy' : 'kanban'));
  }, []);

  if (projectId === undefined) {
    return (
      <div className={styles.wrapper}>
        <ProjectsContainer />
      </div>
    );
  }

  if (cardId === null) {
    return (
      <div className={classNames(styles.wrapper)}>
        <div className={styles.message}>
          <h1>
            {t('common.cardNotFound', {
              context: 'title',
            })}
          </h1>
        </div>
      </div>
    );
  }

  if (board === null) {
    return (
      <div className={classNames(styles.wrapper)}>
        <div className={styles.message}>
          <h1>
            {t('common.boardNotFound', {
              context: 'title',
            })}
          </h1>
        </div>
      </div>
    );
  }

  if (projectId === null) {
    return (
      <div className={classNames(styles.wrapper)}>
        <div className={styles.message}>
          <h1>
            {t('common.projectNotFound', {
              context: 'title',
            })}
          </h1>
        </div>
      </div>
    );
  }

  if (board === undefined) {
    return (
      <div className={classNames(styles.wrapper)}>
        <div className={styles.message}>
          <h1 className={styles.messageTitle}>
            {t('common.openBoard', {
              context: 'title',
            })}
          </h1>
          <div className={styles.messageContent}>
            <Trans i18nKey="common.createNewOneOrSelectExistingOne" />
          </div>
        </div>
      </div>
    );
  }

  if (board.isFetching) {
    return (
      <div className={classNames(styles.wrapper, styles.wrapperLoader, styles.wrapperProject)}>
        <div className={styles.loading}>
          <Spinner size="xl" />
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(styles.wrapper, styles.wrapperLoader, styles.wrapperProject)}>
      {board && !board.isFetching && (
        <BoardActionsContainer viewMode={viewMode} onToggleView={handleToggleView} />
      )}
      <BoardContainer viewMode={viewMode} />
    </div>
  );
}

Static.propTypes = {
  projectId: PropTypes.string,
  cardId: PropTypes.string,
  board: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

Static.defaultProps = {
  projectId: undefined,
  cardId: undefined,
  board: undefined,
};

export default Static;
